import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { Button } from "reactstrap";

//Util
import { fn_getPathTenantCache } from "../utils/sessao.js";

function SessaoExpirada() {
  const navigate = useNavigate();

  const [pathTenant, setPathTenant] = useState(null);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Retira o espaço reservado para o cabeçalho do sistema, que não aparece nesta página
    document.body.classList.add("login");

    setPathTenant(fn_getPathTenantCache());

    return () => {
      document.body.classList.remove("login");
    };
  }, []);

  //### EVENTOS ###
  function handleBotaoLogin() {
    navigate(`/login/${pathTenant}`);
  }

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center">
        <h2>Sessão Expirada</h2>
        <p>Sua sessão expirou. Faça login novamente!</p>

        {pathTenant && (
          <Button name="btnLogin" color="primary" onClick={handleBotaoLogin}>
            Login
          </Button>
        )}
      </div>
    </div>
  );
}

export default SessaoExpirada;
